const IconLoctionSelector = (): JSX.Element => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 5C9.23571 5 7 7.23571 7 10C7 13.75 12 19.2857 12 19.2857C12 19.2857 17 13.75 17 10C17 7.23571 14.7643 5 12 5ZM12.0006 11.7858C11.0148 11.7858 10.2148 10.9858 10.2148 10.0001C10.2148 9.01436 11.0148 8.21436 12.0006 8.21436C12.9863 8.21436 13.7863 9.01436 13.7863 10.0001C13.7863 10.9858 12.9863 11.7858 12.0006 11.7858Z"
          fill="currentColor"
        />
      </svg>
    </>
  );
};

export default IconLoctionSelector;
